<template>
  <div :class="`${classes || ''} flex-row flex-start v-center ${noMargin ? '' : 'bottom-offset2'}`">
    <span
      :class="`${isChecked ? 'checked' : ''} switch`"
      @click="toggle"
    >
      <span class="switch-ball" />
    </span>
    <tr-typography
      v-if="label"
      class="block margin-left"
      variant="body"
    >
      {{ label }}
    </tr-typography>
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue'

export default {
  name: 'TrSwitch',
  components: {
    TrTypography
  },
  props: {
    isChecked: {
      required: false,
      type: Boolean,
      default: false
    },
    onChange: {
      required: true,
      type: Function
    },
    noMargin: {
      required: false,
      type: Boolean
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    classes: {
      required: false,
      type: String,
      default: ''
    }
  },
  methods: {
    toggle() {
      return this.onChange(!this.isChecked);
    }
  }
};
</script>
